import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 40px 32px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 0 16px 32px;
    margin: 0;
  }
`;
